<template>
  <div
    :class="[$.board_container, $.skeleton]"
  >
    <div
      :class="$.columns_container"
    >
      <column-skeleton
        v-for="col in columns"
        :key="`column_skeleton_${col.id}`"
        :data="col"
      />
    </div>
  </div>
</template>

<script>
import ColumnSkeleton from './ColumnSkeleton.vue';

export default {
  name: 'BoardSkeleton',
  components: {
    ColumnSkeleton
  },
  data() {
    return {
      columns: []
    }
  },
  created() {
    // L - large card, S - small card, those types defined in SkeletonCard.vue
    const columns = [
      {
        id: 1,
        cards: ['L', 'S', 'L', 'S', 'L']
      },
      {
        id: 2,
        cards: ['S', 'L', 'S', 'L', 'S']
      },
      {
        id: 3,
        cards: ['L', 'S', 'L', 'S']
      },
      {
        id: 4,
        cards: ['S', 'L', 'L', 'S', 'L']
      }
    ];

    if (window.screen.availWidth < 1920) {
      columns.forEach((col) => {
        col.cards.splice(-2, 2);
      });
    }

    this.columns = columns;
  }
}
</script>

<style lang="less" module="$" src="../less/boardSkeleton.less"></style>
